/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Reason_For_SaleInputs */

const vi_product_lot_history_reason_for_sale = /** @type {(inputs: Product_Lot_History_Reason_For_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất cho đơn hàng`)
};

/**

* @param {Product_Lot_History_Reason_For_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_reason_for_sale = /** @type {((inputs?: Product_Lot_History_Reason_For_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Reason_For_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_reason_for_sale(inputs)
});